(function() {
    'use strict';

    angular
        .module('receiptApp')
        .controller('ReceiptBigger150mDialogController', ReceiptBigger150mDialogController);

    ReceiptBigger150mDialogController.$inject = ['$scope', '$uibModalInstance'];

    function ReceiptBigger150mDialogController ($scope, $uibModalInstance) {
    	var bigger150mDlgCtr = this;
    	bigger150mDlgCtr.cancel= cancel;
    	bigger150mDlgCtr.ok = ok;
	    function ok() {
	    	 window.location.reload();
	    };
	    
	    function cancel() {
		   $uibModalInstance.dismiss('cancel');
	    };
    }
})();
